import { CARD_STYLES } from '../../utils/constants/CSS/cardStyles'

const apiKeyStyles = {
  paddingContainer: {
    marginTop: '15px',
  },
  apiContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '25px',
  },
  copyAlert: {
    marginLeft: '8px',
    color: '#4CAF50',
    fontSize: '14px',
  },
  apiKeyWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  copyIconWrapper: {
    marginLeft: '8px',
  },
  title: {
    fontWeight: 500,
    color: '#333',
  },
}

export default apiKeyStyles
